import React, {Component} from 'react';
import Datetime from 'react-datetime';
import { Row, Column } from 'simple-flexbox';
import { Panel, Button } from "react-bootstrap";

import Alert from "@modules/Alert";
import ComponentHeader from "@components/componentHeader";
import Form from "@sm/core/Form";
import Select from "@modules/Select";
import Spinner from '@components/Spinner';

import PayoutIcon from '@assets/images/payouts.png';
import PayoutIconTrustbucks from '@assets/images/trustbucks/payouts.png';
import PayoutIconT365 from '@assets/images/t365/payouts.png';
import PayoutIconPacificCapital from '@assets/images/pacificCapital/payouts.png';

import '@assets/css/pacificCapital/payouts.scss';
import '@assets/css/t365/payouts.scss';
import '@assets/css/trustbucks/payouts.scss';
import '@assets/css/payouts.css';

import { crudActions } from "@sm/services/crudActions";
import { FETCH_PERMISSIONS } from '@sm/actions/types';
import { whiteLabel } from '@sm/config';
import { getColor } from '@sm/utils/utils';

const combineReducers =  require('@sm/reducers/index');

class EmptyScreen extends Component {
  state = {
    controls: new Form({
      pendingPayouts: null,
      availableBalance: null,
      walletBalance: null,
      clientId: "",
      rollingReserveHold: null,
      balanceToSettle: null,
      withheldFunds: null,
      date: "",
      currency: ""
    }, [{
      name: "currency",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "clientId",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "pendingPayouts",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "availableBalance",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "rollingReserveHold",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "balanceToSettle",
      type: "isNumber",
      rules: {
        required: true
      }
    }, {
      name: "withheldFunds",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "date",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "walletBalance",
      type: "isString",
      rules: {
        required: false
      }
    }]),
    lastUpdate: Datetime.moment().format('HH:mm - DD. MMM YYYY'),
    isSettlements: true,
    fxPairs: [],
    fxRates: [],

    showAlert: false,
    alertType: "success",
    alertMessage: "",
    submitClicked: false,
    loadingLookups: true,
    loadingControls: true,
    isSubmitting: false
  };

  componentDidMount() {
    const { controls } = this.state;
    const { match } = this.props;
    const isInboundSettlement = match && match.path === "/otc-settlement";
    this.setState({
      isSettlements: !isInboundSettlement
    });
    if (isInboundSettlement) {
      this.populateControls();
    }
    const baseUrl = "v1/settlement/lookups";
    const url = isInboundSettlement ? `${baseUrl}?isOtc=true` : baseUrl;

    const requests = [
      crudActions.get(url)
    ];

    if (isInboundSettlement) {
      const fxSettingsRequest = crudActions
        .get('v1/clients/current')
        .then(response => {
          if (response && response.companyId) {
            return crudActions.get(`v1/companies/${response.companyId}/fxsettings`);
          } else {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: "Missing company info."
            });
          }
        }).catch(err => {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: (err && err.message) || "An error occurred while getting company info."
          });
        });

      requests.push(fxSettingsRequest);
    }

    Promise.all(requests)
      .then(([lookups, fxsettings]) => {
        if (lookups) {
          const uniqueCurrencies = [];
          const midCurrency = lookups.mids.map(mid => {
            return {
              value: mid.currency,
              label: mid.currency
            };
          });
          const fxPairsAll = lookups.fxPairs && lookups.fxPairs.length ? lookups.fxPairs.map(pair => { return { value: pair, label: pair };}) : [];
          const settlementFeeData = lookups.settlementFees ? lookups.settlementFees : [];
          if (isInboundSettlement) {
            this.setState({
              settlementFeeData: settlementFeeData
            });
          }
          let currency = midCurrency.filter(element => {
            const isDuplicate = uniqueCurrencies.includes(element.label);
            if (!isDuplicate) {
              uniqueCurrencies.push(element.label);
              return true;
            }
            return false;
          });
          if (isInboundSettlement) {
            currency = settlementFeeData.filter(elem => currency.map(cur => cur.value).includes(elem.currency))
              .map(elem => ({ value: elem.currency, label: elem.currency }));
          }

          currency.sort((elemA, elemB) =>
            elemA.label.localeCompare(elemB.label)
          );

          const fxPairByCurrency =  currency.length && lookups.fxPairs && lookups.fxPairs.length ? lookups.fxPairs.filter(elem => elem.split("/")[1] === currency[0].value) : [];
          this.setState({
            merchant: lookups.merchant,
            ...(isInboundSettlement && fxsettings && { fxRates: fxsettings }),
            controls: Object.assign(controls, {
              clientId: lookups.merchant.value,
              currency: currency.length ? currency[0].value : "",
              ...(isInboundSettlement && currency.length && { settlementFeeValue: settlementFeeData.find(elem => elem.currency === currency[0].value).settlementFee }),
              ...(isInboundSettlement && { fxPair: fxPairByCurrency.length ? fxPairByCurrency[0] : "" }),
              ...(isInboundSettlement && fxPairByCurrency.length && { fxRate: this.loadFxRate(fxPairByCurrency[0], settlementFeeData, fxsettings) }),
            }),
            mids: lookups.mids.map(elem => {
              return {
                value: elem.id,
                label: elem.name,
                clients: elem.clients,
                pspId: elem.pspId,
                currency: elem.currency
              };
            }),
            fxPairsAll: fxPairsAll,
            fxPairs: currency.length ? fxPairsAll.filter(elem => elem.value.split("/")[1] === currency[0].value) : [],
            loadingLookups: false,
            currency: currency,
          }, () => {
            if (currency.length) {
              this.loadNumbers(currency[0].value);
            }
          });
        }
      }).catch((err) => {
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message
          });
        }
      }
      );
  };

  populateControls = () => {
    const { controls } = this.state;
    controls.addField("fxPair", "", {
      name: "fxPair",
      type: "isString",
      rules: {
        required: true
      }
    });
    controls.addField("fxRate", "", {
      name: "fxRate",
      type: "isNumber",
      rules: {
        required: true
      }
    });
    controls.addField("otcBalanceToSettle", "", {
      name: "otcBalanceToSettle",
      type: "isNumber",
      rules: {
        required: true
      }
    });

    controls.addField("settlementFee", "", {
      name: "settlementFee",
      type: "isNumber",
      rules: {
        required: true
      }
    });
    this.setState({
      controls
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
      alertType: "success",
      alertMessage: ""
    });
  };

  onValueChange = (event, field) => {
    const { controls, submitClicked, isSettlements, settlementFeeData, fxPairsAll, fxRates } = this.state;
    const isNumber = controls.fieldRules.find(rule => rule.name === field).type === "isNumber";
    const numberRegex = new RegExp(/^\d+$/);
    if (!event) {
      const matchNumber = event.match(numberRegex);
      controls[field] = isNumber ? parseInt(matchNumber ? matchNumber[0] : controls[field]) : event;
    } else if (event.target) {
      const value = event.target.value.replace(/\./g, "");
      if (value) {
        const matchNumber = value.match(numberRegex);
        controls[field] = isNumber ? parseInt(matchNumber ? matchNumber[0] : controls[field]) : event.target.value;
      } else {
        controls[field] = value;
      }
    } else if (event.value) {
      const matchNumber = typeof event.value === "number" ? [event.value] : event.value.match(numberRegex);
      controls[field] = isNumber ? parseInt(matchNumber ? matchNumber[0] : controls[field]) : event.value;
    } else {
      controls[field] = event.map(elem => elem.value);
    }

    if (field === "currency") {
      this.loadNumbers(controls.currency);

      const pendingPayoutsField = controls.fieldRules.find(rule => rule.name === "pendingPayouts");
      const availableBalanceField = controls.fieldRules.find(rule => rule.name === "availableBalance");
      const rollingReserveHoldField = controls.fieldRules.find(rule => rule.name === "rollingReserveHold");

      pendingPayoutsField.rules.required = false;
      availableBalanceField.rules.required = false;
      rollingReserveHoldField.rules.required = false;
      if (!isSettlements) {
        const fxPairs = fxPairsAll.filter(pair => pair.value.split("/")[1] === controls.currency);
        controls.fxPair = fxPairs.length ? fxPairs[0].value : "";
        this.loadFxRate(controls.fxPair, settlementFeeData, fxRates);
        this.setState({
          fxPairs : fxPairs
        });
        controls.settlementFeeValue = settlementFeeData.find(elem => elem.currency === controls.currency).settlementFee;
        controls.balanceToSettle = "";
        controls.otcBalanceToSettle = "";
      }
    }

    if (field === "fxPair" || field === "currency" || field === "balanceToSettle") {
      if (field === "fxPair") {
        controls.fxRate = this.loadFxRate(controls.fxPair, settlementFeeData, fxRates);
      } else {
        this.recalculateInboundSettlement(controls);
      }
    }

    if (submitClicked) {
      controls.isFormValid();
    }

    this.setState({
      controls
    });
  };

  addMarkUp = (value, currency, settlementFeeData) => {
    const markUp = settlementFeeData.find(elem => elem.currency === currency).markUp;
    if (markUp) {
      const finalValue = value * (1 + markUp / 100);
      return Number(finalValue.toFixed(2));
    } else {
      return value;
    }
  };

  getFxRateValue = (fxPair, fxRates, settlementFeeData) => {
    const currencies = fxPair.split("/");
    const fxRate = fxRates.find(elem => elem.baseCurrency === currencies[0] && elem.currency === currencies[1]);
    const markUp = settlementFeeData.find(elem => elem.currency === currencies[1]).markUp;
    if (fxRate && markUp) {
      const finalFxRate = fxRate.exchangeRate * (1 + markUp / 100);
      return Number(finalFxRate.toFixed(2));
    } else {
      return "";
    }
  };

  recalculateInboundSettlement = (controls) => {
    const { isSettlements } = this.state;
    if (!isSettlements && controls.currency && controls.balanceToSettle && controls.fxPair) {
      const exchanged = controls.balanceToSettle / controls.fxRate;
      const calculatedSettlementFee = exchanged * (controls.settlementFeeValue / 100);
      const calculatedBalance =  exchanged - calculatedSettlementFee;
      controls.fullOtcBalance = Number(exchanged.toFixed(2));
      controls.settlementFee = Number(calculatedSettlementFee.toFixed(2));
      controls.otcBalanceToSettle = Number(calculatedBalance.toFixed(2));
      this.setState({
        controls: controls
      });
    }

    if (!controls.balanceToSettle) {
      controls.otcBalanceToSettle = "";
      controls.fullOtcBalance = "";
      controls.settlementFee = "";
      this.setState({
        controls: controls
      });
    }
  };

  loadNumbers = (cur) => {
    const { controls, isSettlements } = this.state;
    const date = Datetime.moment().format("DD.MM.YYYY");
    this.setState({
      loadingControls: true
    });

    crudActions.get(`v1/settlement/${controls.currency}?date=${date}`).then(
      (numbers) => {
        if (numbers) {
          const balanceToSettleField = controls.fieldRules.find(fieldRule => fieldRule.name === "balanceToSettle");
          balanceToSettleField.rules.max = numbers.availableBalance;

          this.setState({
            controls: Object.assign(controls, {
              date,
              availableBalance: isSettlements ? numbers.availableBalance : numbers.collectedFunds,
              pendingPayouts: numbers.pendingPayouts,
              rollingReserveHold: numbers.rollingReserveHeld,
              walletBalance: numbers.walletBalance,
              withheldFunds: numbers.withheldFunds
            }),
            loadingControls: false
          });
        }
      }
    ).catch(
      (err) => {
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message,
            loadingControls: false
          });
        }
      }
    );
  };

  loadFxRate = (fxPair, settlementFeeData, fxRates) => {
    const { controls } = this.state;
    var fxRateFinal = 0;
    this.setState({
      loadingControls: true
    });

    const encodedFxPair = encodeURIComponent(fxPair);
    crudActions.get(`v1/settlement/fxaverage?fxPair=${encodedFxPair}`).then(
      (fxRate) => {
        if (fxRate) {
          fxRateFinal = this.addMarkUp(fxRate, fxPair.split("/")[1], settlementFeeData);
          this.setState({
            controls: Object.assign(controls, {
              fxRate: fxRateFinal
            }),
            loadingControls: false
          });
          this.recalculateInboundSettlement(controls);
        } else {
          fxRateFinal = this.getFxRateValue(fxPair, fxRates, settlementFeeData);
          this.setState({
            controls: Object.assign(controls, {
              fxRate:  fxRateFinal
            }),
            loadingControls: false
          });
          this.recalculateInboundSettlement(controls);
        }
      }
    ).catch(
      (err) => {
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message,
            loadingControls: false
          });
        }
      }
    );
    return  fxRateFinal;
  };

  onRequestSettlement = () => {
    const { controls, isSettlements, currency, settlementFeeData, fxPairsAll, fxRates } = this.state;
    const isControlsValid = controls.isFormValid();
    this.setState({
      controls,
      submitClicked: true
    });

    if (isControlsValid) {
      this.setState({
        isSubmitting: true
      });
      const url = isSettlements ? "v1/settlement" : "v1/merchant/otc/settlement";
      const data = controls.data();
      if (!isSettlements) {
        data.fullOtcBalance = controls.fullOtcBalance;
      }
      crudActions.post(url, data).then(
        () => {
          const fxPairByCurrency =  currency.length ? fxPairsAll.filter(elem => elem.value.split("/")[1] === currency[0].value) : [];
          const newControl = Object.assign(controls, {
            currency: currency.length ? currency[0].value : "",
            balanceToSettle: "",
            ...(!isSettlements && currency.length && { settlementFeeValue: settlementFeeData.find(elem => elem.currency === currency[0].value).settlementFee }),
            ...(!isSettlements && fxPairByCurrency.length && { fxPair: fxPairByCurrency[0].value }),
            ...(!isSettlements && { otcBalanceToSettle: "" }),
          });
          const fxPairs = fxPairsAll.filter(pair => pair.value.split("/")[1] === controls.currency);
          controls.fxPair = fxPairs.length ? fxPairs[0].value : "";
          this.loadFxRate(controls.fxPair, settlementFeeData, fxRates);
          this.setState({
            showAlert: true,
            alertType: "success",
            alertMessage: "Settlement successfully requested.",
            isSubmitting: false,
            controls: newControl,
            fxPairs : fxPairs
          }, () => {
            if (currency.length) {
              this.loadNumbers(currency[0].value);
            }
            if (fxPairByCurrency.length) {
              this.loadFxRate(fxPairByCurrency[0], settlementFeeData, fxRates);
            }
          });
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message,
              isSubmitting: false
            });
            if (err.message === "OTC is not enabled") {
              crudActions.get(`v1/myaccount/me`).then(
                (user) => {
                  if (user) {
                    combineReducers.default.dispatch({
                      type: FETCH_PERMISSIONS,
                      payload: user.permissions,
                      roleId: user.roleId,
                      wlOtcEnabled: user.wlOtcEnabled
                    });
                  }
                }
              ).catch(
                (error) => {
                  if (error && error.message) {
                    this.setState({
                      showAlert: true,
                      alertType: "error",
                      alertMessage: error.message,
                      isSubmitting: false
                    });
                  }
                }
              );
            }
          }
        }
      );
    }
  };

  getValue = (value, defaultValue) => {
    if (!value && value !== 0) {
      return defaultValue;
    } else if (value === 0) {
      return 0;
    }

    return value;
  };

  getIcon = () => {
    switch (whiteLabel) {
    case "t365":
      return PayoutIconT365;
    case "trustbucks":
      return PayoutIconTrustbucks;
    case "pacificCapital":
      return PayoutIconPacificCapital;
    default:
      return PayoutIcon;
    }
  };

  render() {
    const { showAlert, alertType, alertMessage, fxPairs, loadingLookups, merchant, controls, loadingControls, currency, isSubmitting,
      isSettlements } = this.state;
    let currencyValue = controls.currency;

    if (typeof currencyValue === 'string' && currency && controls.currency) {

      currencyValue = currency.find(el => el.label === controls.currency).value;
    }
    return (
      <Row flexGrow={ 1 } className={ `${whiteLabel} module apidata request-settlement` } vertical='start'>
        <Column flexGrow={ 1 }>
          <ComponentHeader
            title={ isSettlements ? "Request Settlement" : "OTC Settlement Request" }
            lastUpdate={ this.state.lastUpdate }
            img={ this.getIcon() }
          />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    SELECT
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  { loadingLookups ? (
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : loadingControls && controls.currency ? (
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : (
                    <div className="panel-content" style={ {overflow: 'unset'} }>
                      <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Merchant </label>
                            <input
                              className={ `form-control ${controls.errors.has('clientId') ? 'error-field' : ""}` }
                              value={ merchant ? merchant.label : "" }
                              disabled
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Currency </label>
                            <Select
                              className={ controls.errors.has('currency') ? 'error-field' : "" }
                              value={ currencyValue }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, 'currency') }
                              options={ currency }
                            />
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Payout Wallet Balance </label>
                            <input
                              className={ `form-control ${controls.errors.has('walletBalance') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.walletBalance, "n/a") }
                              disabled
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Disputed Funds </label>
                            <input
                              className={ `form-control ${controls.errors.has('withheldFunds') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.withheldFunds, 0) }
                              disabled
                            />
                          </Column>
                        </Row>
                      </Row>
                      <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Pending Payouts </label>
                            <input
                              className={ `form-control ${controls.errors.has('pendingPayouts') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.pendingPayouts, "Select CURRENCY first.") }
                              disabled
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Rolling Reserve Hold </label>
                            <input
                              className={ `form-control ${controls.errors.has('rollingReserveHold') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.rollingReserveHold, "Select CURRENCY first.") }
                              disabled
                            />
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> { !isSettlements ? `Collected Balance` :`Available Balance` }  </label>
                            <input
                              className={ `form-control ${controls.errors.has('availableBalance') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.availableBalance, "Select CURRENCY first.") }
                              disabled
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> { !isSettlements ? `Balance to Exchange` :`Balance to Request` } </label>
                            <input
                              className={ `form-control ${controls.errors.has('balanceToSettle') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.balanceToSettle, "") }
                              type="text"
                              disabled={ !controls.currency }
                              onChange={ (value) => this.onValueChange(value, 'balanceToSettle') }
                            />
                          </Column>
                        </Row>
                      </Row>
                      { (!isSettlements) &&
                      <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> FX Pair </label>
                            <Select
                              className={ controls.errors.has('fxPair') ? 'error-field' : "" }
                              value={ controls.fxPair }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, 'fxPair') }
                              options={ fxPairs }
                              disabled={ !controls.currency || fxPairs.length === 1 }
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> FX Rate </label>
                            <input
                              className={ `form-control ${controls.errors.has('fxRate') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.fxRate, "Select FX pair first.") }
                              disabled
                            />
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Settlement Fee </label>
                            <input
                              className={ `form-control ${controls.errors.has('settlementFee') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.settlementFee, "Fill in Balance to exchange field.") }
                              disabled
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Requested Settlement </label>
                            <input
                              className={ `form-control ${controls.errors.has('otcBalanceToSettle') ? 'error-field' : ""}` }
                              value={ this.getValue(controls.otcBalanceToSettle, "Fill in all fields") }
                              disabled
                            />
                          </Column>
                        </Row>
                      </Row>
                      }
                      <Row flexGrow={ 1 } horizontal='end' wrap={ true } vertical='end'>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='end' vertical='end' alignSelf='end'>
                          <Column flexGrow={ 1 } className="input-column empty-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } className="input-column empty-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } className="input-column empty-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 }   vertical='end' alignSelf='end' className="input-column" style>
                            <Button
                              type="submit"
                              className="btn defaultBtn"
                              disabled={ isSubmitting }
                              onClick={ () => this.onRequestSettlement() }>
                              SUBMIT
                            </Button>
                          </Column>
                        </Row>
                      </Row>
                    </div>
                  )}
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>

        {showAlert && (
          <Alert
            show={ showAlert }
            title={ alertType }
            type={ alertType }
            text={ alertMessage }
            confirmButtonColor={ alertType === "success" ? getColor(whiteLabel) : "#DD6B55" }
            onConfirm={ this.onConfirm }
          />
        )}

      </Row>
    );
  }
}

export default EmptyScreen;
